import {useEffect, useState} from 'react'
import Mapa from './Mapa'
import Tabla from './Tabla'
import {Box, Button, LinearProgress, } from "@material-ui/core";
import axios from 'axios';
import qs from 'qs';
import { useHistory } from "react-router-dom";
import Modal from '../../generales/ModalCerrarActualiza';
import {llamaApiCargaToken,ErrorGeneral,llamadaApiCarga } from '../../funciones/ClienteAxios';
import { toast } from 'react-toastify'; 

const MapaPoligono =({ruta, modalAbierto,setModalAbierto ,titulo, auxReg, getDatos, listRutaGps})=>{
    let history = useHistory();    
    const source = axios.CancelToken.source();  
    const Dispvo =localStorage.getItem('Dispvo') ;    
    const auxDispV =Dispvo.length >= 12 ? Dispvo:'451224452121'  
    const usuId =localStorage.getItem('UsuId') ;                    
    const [espera,setEspera]= useState(false);    
    const [mensaje, setMensaje] = useState("");
    const [tipoAdvertencia, setTipoAdvertencia] = useState("success");
    const [btnDeshabilitado,setBtnDeshabilitado]= useState(false)
    const [aviso, setAviso] = useState(false); 
    const[lista, setLista]= useState([])
    const[bandera, setBandera]= useState(true)
    const [contador, setContador] = useState(1);
    const[registro, setRegistro] = useState({Llave:0, Tipo:"", Distrito:"", Alias:"", Descr:"" })  
    const{Llave, Tipo, Distrito, Alias, Descr  }=registro
        

     useEffect(()=>{    
        let auxContador=contador
        //console.log(listRutaGps);
        
        const auxLocalStg =[]
        listRutaGps.forEach(element => {
            const geometry = { coordinates:[element[0], element[1]] } 
            const properties = {texto:"Nvo Marcador"}    
            const nvoMarcador = {geometry, properties, original:{Id:contador}}                       
            auxLocalStg.push(nvoMarcador)            
            auxContador++
        });
        localStorage.setItem(`auxPolR${ruta.Id}`, JSON.stringify(auxLocalStg))
        setContador(auxContador)          
        setBandera(!bandera)

        return ()=> {
            localStorage.removeItem(`auxPolR${ruta.Id}`)
            source.cancel();
        } 
    },[])

    useEffect(()=>{
        if (!bandera) {
            setTimeout(() => {
                const auxLocalStg =  localStorage.getItem(`auxPolR${ruta.Id}`) ?  JSON.parse(localStorage.getItem(`auxPolR${ruta.Id}`)):[]
                if (auxLocalStg.length!==0) {
                    setLista(auxLocalStg)
                }
                setBandera(true)
            }, 300);
        }
    },[bandera])

    const limpiar =()=>{
        localStorage.removeItem(`auxPolR${ruta.Id}`)
        setBandera(false)
        setLista([])
        setContador(1)
    }

    const funcionUltimo =()=>{
        const auxLocalStg =  localStorage.getItem(`auxPolR${ruta.Id}`) ?  JSON.parse(localStorage.getItem(`auxPolR${ruta.Id}`)):[]
        if (auxLocalStg.length!==0) {
            if (auxLocalStg.length===1) {
                limpiar()
            }
            else{
                auxLocalStg.pop()
                localStorage.setItem(`auxPolR${ruta.Id}`,JSON.stringify(auxLocalStg))
                setContador(contador-1)
                setBandera(false)
            }            
        }        
    }

     const getNvoGPS = ( listaGps) => {       
    
        const data = qs.stringify({
            Usuario:usuId,
            Ruta:ruta.Id,
            poligono:JSON.stringify(listaGps),
            ip:"127.0.0.0",
            idDispositivo: auxDispV,
        });
        const url = "lugar/ruta/gps/edit";
        function respuesta(aux) {
            if (aux.length!==0)
            {   setBtnDeshabilitado(true)                                             
                //const mensaje=auxReg.length !==0 ?"Se edito correctamente":"Se registro correctamente"
                const mensaje="Se registro correctamente."
                setTipoAdvertencia("success")      
                setMensaje(mensaje);                
                setAviso(false);
                toast.success(mensaje,{
                    pauseOnFocusLoss: false,                    
                    toastId: `nvo-afil${1}`
                })          
                getDatos(ruta.Id )      
                setModalAbierto(false);                            
            }
        }
        llamaApiCargaToken(data, url, respuesta,ErrorGeneral,setEspera,history,source);
    };
    
    const verificaNulos = (campo,descripcion)=>{
        let respuesta =false;                  
        if( campo===null || (typeof campo !== 'number' && typeof campo === 'string' 
            && (campo.trim() === '' || campo.trim() === null) )
        ) 
        {   respuesta=true;                                   
            setMensaje('No se lleno el campo '+descripcion);
            setTipoAdvertencia("warning")  
            setAviso(respuesta);
        }
        return(respuesta);
    }   

    const validaLista=()=>{
        let respuesta =false;                  
        if( ruta.ObjId === 1 && lista.length<=1  )        
        {   respuesta=true;                                   
            setMensaje('Debe seleccionar 2 puntos fijos minimo ');
            setTipoAdvertencia("warning")  
            setAviso(respuesta);
        }        
        else{
            if( ruta.ObjId === 2 && lista.length<=2  )        
            {   respuesta=true;                                   
                setMensaje('Debe seleccionar 3 puntos fijos minimo ');
                setTipoAdvertencia("warning")  
                setAviso(respuesta);
            }        
        }
        return(respuesta);
    }

    function guardarDatos(e)
    {   e.preventDefault()                
        //serCambioEfectivo(true)          
        if (bandera && !validaLista() )
        {           
            setMensaje('');                
            setAviso(false);                
            let nvoArr =[]    
            lista.forEach((gps)=>{
                nvoArr.push({lt: gps.geometry.coordinates[1], ln: gps.geometry.coordinates[0]})
            })

            if (ruta.ObjId === 2) {
                nvoArr.push({lt: lista[0].geometry.coordinates[1], ln: lista[0].geometry.coordinates[0]})
            }

            //console.log(nvoArr);
            
            getNvoGPS(nvoArr )                               
        }                                  
    } 

    const cerrarBorrar = () => {            
        setAviso(false);
        setModalAbierto(false);
    };

    return(
    <Modal
        titulo={titulo} modalAbierto={modalAbierto}
        setModalAbierto={setModalAbierto} guardarDatos={guardarDatos}
        mensaje={mensaje} tipoAdvertencia={tipoAdvertencia}
        aviso={aviso} btnDeshabilitado={btnDeshabilitado}
        setAviso={setAviso} tamanio={'lg'} cargando={espera}     
        cerrarBorrar={cerrarBorrar}   
    >
    <Box display={"flex"} >
        <Box width={"801px"} height="30rem"> 
            <Box mb={2}>
                <Button onClick={limpiar} style={{ backgroundColor:process.env.REACT_APP_Btn_Color}}  variant='contained'   color="primary" >Limpiar</Button>
                <Button onClick={funcionUltimo} style={{marginLeft:"1rem", backgroundColor:process.env.REACT_APP_Btn_Color}} variant='contained'   color="primary" >Borrar ultimo</Button>
            </Box>
            {bandera ? 
                <Mapa lista={lista} setLista={setLista} setActualiza={()=>setBandera(!bandera)} 
                    contador={contador} setContador={setContador} ruta={ruta} 
                    listRutaGps={listRutaGps}
                />
            :<Box mt={5}><LinearProgress/></Box>}
        </Box>
        {/* <Box>
           
            <Tabla lista={lista} bandera={bandera} />
        </Box> */}
    </Box>
    </Modal>)
}

export default MapaPoligono